// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overtimeSettingsContainer {
  /* padding: 30px; */
  max-width: 800px;
  margin: 0 !important;
  padding: 0 !important;
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.conditionsList {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.conditionItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px 15px 20px;
  border-radius: 8px;
  background-color: white;
  max-width: 600px;
}

.conditionInfo {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 80%;
}

.conditionText {
  font-size: 18px;
  font-weight: bold;
}

.conditionDescription {
  font-size: 14px;
  color: #666;
}

/* 토글 스위치 스타일 */
.toggleSwitch {
  margin-left: 0;
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.toggleSwitch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #FF8F45; /* 메인 색상(오렌지)으로 변경 */
}

input:focus + .slider {
  box-shadow: 0 0 1px #FF8F45;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* 토글 힌트 스타일 */
.toggleHint {
  position: absolute;
  right: 80px;
  background-color: #ffe9c3;
  color: #333;
  padding: 8px 15px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
}

.toggleHint:after {
  content: "";
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent #ffe9c3;
}

.largeText {
  font-size: 20px; /* 텍스트 크기를 30포인트로 설정 */
}

/* 추가 CSS */
.updateLoader {
  background-color: rgba(255, 143, 69, 0.1);
  color: #FF8F45;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
}

/* 섹션 제목 스타일 */
.sectionTitle {
  color: #000;
  margin-top: 100px; /* 50px에서 80px로 증가 */
  padding-top: 40px; /* 추가 상단 패딩 */
} `, "",{"version":3,"sources":["webpack://./src/styles/OvertimeSettings.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;AACjD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,eAAe,EAAE,sBAAsB;AACzC;;AAEA,WAAW;AACX;EACE,yCAAyC;EACzC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,iBAAiB,EAAE,oBAAoB;EACvC,iBAAiB,EAAE,aAAa;AAClC","sourcesContent":[".overtimeSettingsContainer {\n  /* padding: 30px; */\n  max-width: 800px;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.conditionsList {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.conditionItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 30px 15px 20px;\n  border-radius: 8px;\n  background-color: white;\n  max-width: 600px;\n}\n\n.conditionInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  width: 80%;\n}\n\n.conditionText {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.conditionDescription {\n  font-size: 14px;\n  color: #666;\n}\n\n/* 토글 스위치 스타일 */\n.toggleSwitch {\n  margin-left: 0;\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.toggleSwitch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #FF8F45; /* 메인 색상(오렌지)으로 변경 */\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #FF8F45;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n/* 토글 힌트 스타일 */\n.toggleHint {\n  position: absolute;\n  right: 80px;\n  background-color: #ffe9c3;\n  color: #333;\n  padding: 8px 15px;\n  border-radius: 4px;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.toggleHint:after {\n  content: \"\";\n  position: absolute;\n  right: -10px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent transparent #ffe9c3;\n}\n\n.largeText {\n  font-size: 20px; /* 텍스트 크기를 30포인트로 설정 */\n}\n\n/* 추가 CSS */\n.updateLoader {\n  background-color: rgba(255, 143, 69, 0.1);\n  color: #FF8F45;\n  padding: 10px;\n  border-radius: 5px;\n  text-align: center;\n  margin-bottom: 20px;\n  font-weight: bold;\n}\n\n/* 섹션 제목 스타일 */\n.sectionTitle {\n  color: #000;\n  margin-top: 100px; /* 50px에서 80px로 증가 */\n  padding-top: 40px; /* 추가 상단 패딩 */\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
